module.exports = __webpack_public_path__ + "media/a6.3c93baba.wav";